import { useState } from 'react';
import { CalendarClock } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Met un ou plusieurs produits existants (rupture / stock bas) en précommande fournisseur.
export const QuickPreorderModal = ({ products, onClose, onDone }) => {
  const single = products.length === 1 ? products[0] : null;
  const [date, setDate] = useState(single?.preorder_expected_date || '');
  const [qty, setQty] = useState(single?.preorder_qty || '');
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!date) { toast.error("Indiquez la date d'arrivée prévue"); return; }
    setSaving(true);
    try {
      await Promise.all(products.map(p => axios.put(`${API_URL}/api/products/${p.id}`, {
        preorder_enabled: true,
        preorder_expected_date: date,
        preorder_qty: parseInt(qty || 0, 10),
      })));
      toast.success(`${products.length} produit(s) mis en précommande`);
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Échec de la mise en précommande');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" data-testid="quick-preorder-modal">
      <div className="bg-[color:var(--color-surface)] border border-[color:rgb(var(--primary-rgb)/0.40)] p-6 w-full max-w-md">
        <h3 className="text-white text-lg mb-1 flex items-center gap-2">
          <CalendarClock className="w-5 h-5 text-[color:var(--color-primary)]" /> Mettre en précommande
        </h3>
        <p className="text-zinc-400 text-sm mb-4">
          {single ? `${single.brand} — ${single.name} (stock actuel : ${single.stock})` : `${products.length} produits sélectionnés`}
        </p>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-zinc-500 text-xs uppercase tracking-widest mb-2 block">Date d'arrivée prévue *</label>
            <input type="date" value={date} onChange={(e) => setDate(e.target.value)}
              className="w-full bg-transparent border border-white/10 focus:border-[color:var(--color-primary)] text-white px-3 py-2.5 outline-none"
              data-testid="quick-preorder-date" autoFocus />
          </div>
          <div>
            <label className="text-zinc-500 text-xs uppercase tracking-widest mb-2 block">
              Qté commandée{single ? '' : ' (par produit)'}
            </label>
            <input type="number" min="0" value={qty} onChange={(e) => setQty(e.target.value)} placeholder="0"
              className="w-full bg-transparent border border-white/10 focus:border-[color:var(--color-primary)] text-white px-3 py-2.5 outline-none"
              data-testid="quick-preorder-qty" />
          </div>
        </div>
        <p className="text-zinc-500 text-xs mt-3">
          Le produit reste visible au catalogue et apparaît dans l'onglet client « Précommande ». Le stock actuel n'est pas modifié :
          il sera augmenté lors de la validation de la réception.
        </p>
        <div className="flex justify-end gap-3 mt-6">
          <button type="button" onClick={onClose} className="px-4 py-2 border border-white/10 text-zinc-400 hover:text-white text-sm">Annuler</button>
          <button type="button" onClick={submit} disabled={saving}
            className="px-4 py-2 bg-[color:var(--color-primary)] text-black hover:bg-[color:var(--color-primary-hover)] disabled:opacity-50 text-sm font-medium"
            data-testid="quick-preorder-confirm">
            {saving ? 'Enregistrement...' : 'Mettre en précommande'}
          </button>
        </div>
      </div>
    </div>
  );
};
